var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ItemValueWrapperViewModel } from "survey-creator-core";
import * as React from "react";
import { attachKey2click, ReactElementFactory, SurveyPanel, SvgIcon } from "survey-react-ui";
import { CreatorModelElement } from "./ModelElement";
var ItemValueAdornerComponent = /** @class */ (function (_super) {
    __extends(ItemValueAdornerComponent, _super);
    function ItemValueAdornerComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onBlur = function (event) {
            _this.model.onFocusOut(event.nativeEvent);
        };
        _this.rootRef = React.createRef();
        return _this;
    }
    ItemValueAdornerComponent.prototype.createModel = function (props) {
        this.model = new ItemValueWrapperViewModel(props.componentData.creator, props.question, props.item);
    };
    ItemValueAdornerComponent.prototype.getUpdatedModelProps = function () {
        return ["question", "item"];
    };
    ItemValueAdornerComponent.prototype.getStateElement = function () {
        return this.model;
    };
    ItemValueAdornerComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.props.item.setRootElement(this.rootRef.current);
        if (prevProps.item !== this.props.item && prevProps.item) {
            prevProps.item.setRootElement(undefined);
        }
    };
    ItemValueAdornerComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.props.item.setRootElement(this.rootRef.current);
    };
    ItemValueAdornerComponent.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.props.item.setRootElement(undefined);
    };
    ItemValueAdornerComponent.prototype.render = function () {
        var _this = this;
        this.model.item = this.props.item;
        var button = this.model.allowAdd ? (attachKey2click(React.createElement("span", { role: "button", className: "svc-item-value-controls__button svc-item-value-controls__add", "aria-label": this.model.tooltip, onClick: function () {
                _this.model.add(_this.model);
                _this.model.isNew = false;
            } },
            React.createElement(SvgIcon, { size: "auto", iconName: "icon-add_16x16", title: this.model.tooltip })))) : (React.createElement(React.Fragment, null,
            " ",
            this.model.isDraggable ? (React.createElement("span", { className: "svc-item-value-controls__button svc-item-value-controls__drag" },
                React.createElement(SvgIcon, { className: "svc-item-value-controls__drag-icon", size: "auto", iconName: "icon-drag-24x24", title: this.model.dragTooltip }))) : null,
            this.model.allowRemove ? attachKey2click(React.createElement("span", { role: "button", className: "svc-item-value-controls__button svc-item-value-controls__remove", "aria-label": this.model.tooltip, onClick: function () { return _this.model.remove(_this.model); } },
                React.createElement(SvgIcon, { size: "auto", iconName: "icon-remove_16x16", title: this.model.tooltip }))) : null));
        var itemkey = this.props.element.key + (this.model.allowAdd ? "_new" : "");
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: this.rootRef, className: "svc-item-value-wrapper" +
                    (this.model.allowAdd ? " svc-item-value--new" : "") +
                    (this.model.isDragging ? " svc-item-value--dragging" : "") +
                    (this.model.isDragDropGhost ? " svc-item-value--ghost" : "") +
                    (this.model.isDragDropMoveDown ? " svc-item-value--movedown" : "") +
                    (this.model.isDragDropMoveUp ? " svc-item-value--moveup" : ""), key: itemkey, "data-sv-drop-target-item-value": this.model.isDraggable ? this.model.item.value : undefined, onPointerDown: function (event) { return _this.model.onPointerDown(event); } },
                React.createElement("div", { className: "svc-item-value__ghost" }),
                React.createElement("div", { className: "svc-item-value-controls", onBlur: this.onBlur }, button),
                React.createElement("div", { className: "svc-item-value__item", onClick: function (event) { return _this.model.select(_this.model, event.nativeEvent); } }, this.props.element),
                this.renderPanelAction()),
            this.renderPanel()));
    };
    ItemValueAdornerComponent.prototype.renderPanelAction = function () {
        var _this = this;
        if (!this.model.canShowPanel())
            return null;
        var isShowPanel = this.model.showPanel;
        var icName = isShowPanel ? "icon-collapsepanel-16x16" : "icon-expandpanel-16x16";
        var btn = attachKey2click(React.createElement("span", { role: "button", className: "svc-item-value-controls__button svc-item-value-controls__add svc-choice-elements-button", onClick: function () {
                _this.model.togglePanel();
            } },
            React.createElement(SvgIcon, { size: "auto", iconName: icName })));
        return React.createElement("div", { className: "svc-item-value-controls svc-choice-elements-button-container" }, btn);
    };
    ItemValueAdornerComponent.prototype.renderPanel = function () {
        if (!this.model.showPanel)
            return null;
        var creator = this.model.creator;
        var survey = creator.survey;
        return React.createElement(ChoiceItemPanel, { element: this.model.item.panel, survey: survey, creator: creator, css: survey.getCss() });
    };
    return ItemValueAdornerComponent;
}(CreatorModelElement));
export { ItemValueAdornerComponent };
var ChoiceItemPanel = React.memo(function (_a) {
    var element = _a.element, survey = _a.survey, creator = _a.creator, css = _a.css;
    return React.createElement(SurveyPanel, { element: element, survey: survey, creator: creator, cssClasses: css });
});
ChoiceItemPanel.displayName = "ChoiceItemPanel";
ReactElementFactory.Instance.registerElement("svc-item-value", function (props) {
    return React.createElement(ItemValueAdornerComponent, props);
});
